var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 714,
    viewBox: "0 0 680 714",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M388.276 279.014L383.79 271.382L359.253 285.805L363.739 293.438L349.708 318.222L340.86 318.284L341.065 346.762L349.913 346.7L364.312 371.28L359.949 378.974L384.671 393.049L389.034 385.334L417.483 385.129L421.969 392.782L446.486 378.358L442 370.705L456.051 345.941L464.899 345.859L464.694 317.381L455.846 317.443L441.447 292.863L445.81 285.169L421.067 271.094L416.705 278.809L388.276 279.014Z",
    fill: "white",
    stroke: "url(#paint0_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M402.716 309.277C415.292 309.195 425.553 319.31 425.635 331.907C425.717 344.505 415.619 354.784 403.043 354.866C390.467 354.948 380.206 344.833 380.124 332.236C380.022 319.659 390.14 309.379 402.716 309.277Z",
    fill: "white",
    stroke: "url(#paint1_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.411 189.784C108.411 189.784 52.7614 238.492 114.433 300.434",
    stroke: "url(#paint2_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6229 460.592C51.594 474.277 34.3277 487.428 46.6988 506.468C55.2398 519.599 72.3831 524.277 65.706 542.927C63.0639 550.313 58.0048 555.915 59.5205 564.224C60.8518 571.467 66.5048 577.17 71.4819 582.156C75.7626 586.444 82.6446 590.486 85.8193 595.739C91.0217 604.294 85.6964 610.737 83.2385 619.231C80.8831 627.335 80.5145 636.281 85 643.852C90.9398 653.864 102.533 654.869 110.172 662.194C110.172 662.194 145.299 685.194 159.677 642.744C163.077 632.711 168.116 623.519 165.678 612.152C163.835 603.556 157.486 597.236 150.255 592.887C142.677 588.332 134.423 587.224 132.416 577.417C131.187 571.405 133.481 563.752 133.706 557.7C133.972 550.642 134.239 542.599 130.306 536.403C125.78 529.263 118.263 528.606 111.299 524.995C93.7458 515.865 103.147 500.764 100.484 485.315C96.6337 462.931 75.0458 465.064 59.8687 460.489L59.6229 460.592Z",
    fill: "#D4E6FC",
    stroke: "#D4E6FC",
    strokeWidth: 0.1554,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5916 495.861L140.854 667.59",
    stroke: "url(#paint3_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.459 555.279L103.024 570.995",
    stroke: "url(#paint4_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.319 635.604L142.677 611.824",
    stroke: "url(#paint5_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1554 548.323L101.201 526.76",
    stroke: "url(#paint6_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.119 457.165H253.648V376.594L118.119 396.886V457.165Z",
    fill: "url(#paint7_linear_361_3395)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.153 668.431L137.311 646.642H155.192V668.431H116.153Z",
    fill: "url(#paint8_linear_361_3395)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M232.531 668.431L218.849 646.642H200.969V668.431H232.531Z",
    fill: "url(#paint9_linear_361_3395)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242.998 456.755V652.407H188.188V496.333H181.04L170.983 652.407H116.153L126.21 496.333L128.77 456.755H242.998Z",
    fill: "white",
    stroke: "url(#paint10_linear_361_3395)",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M269.133 360.078C269.133 314.837 234.559 294.669 189.417 293.602C188.495 293.581 187.553 293.561 186.611 293.561C118.693 293.561 97.2687 343.007 94.053 351.542C86.8843 370.541 66.7301 430.123 131.678 457.678C151.218 465.967 165.187 445.86 175.612 440.485C193.8 431.108 200.354 428.769 200.354 428.769L269.133 360.078Z",
    fill: "url(#paint11_linear_361_3395)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M239.045 382.606C239.045 382.606 246.295 415.679 286.788 408.539C327.281 401.399 315.442 339.006 315.442 339.006H284.105L282.958 367.71C282.958 367.71 266.347 324.562 245.517 309.769C232.839 300.783 239.045 382.606 239.045 382.606Z",
    fill: "url(#paint12_linear_361_3395)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M253.177 369.639V403.984",
    stroke: "white",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M159.308 450.292L170.717 461.782L179.893 472.656L176.042 476.513L179.422 480.986L160.394 495.799L135.672 466.029L159.308 450.292Z",
    fill: "white",
    stroke: "url(#paint13_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M175.469 483.858L167.296 474.502",
    stroke: "url(#paint14_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M170.102 487.531L161.93 478.195",
    stroke: "url(#paint15_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M165.064 491.573L156.892 482.237",
    stroke: "url(#paint16_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M176.145 476.718L170.102 469.742",
    stroke: "url(#paint17_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M128.811 371.362C111.626 408.108 164.306 448.568 164.306 448.568L132.784 472.102C132.784 472.102 90.4277 436.197 88.2566 411.904",
    fill: "url(#paint18_linear_361_3395)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M182.801 273.433C182.801 273.433 162.729 278.645 161.541 254.188C160.333 229.752 199.514 220.93 208.731 231.147C217.948 241.365 182.801 273.433 182.801 273.433Z",
    fill: "url(#paint19_linear_361_3395)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M184.686 306.835C191.526 306.835 197.057 301.275 197.057 294.443V254.147H172.294V294.443C172.294 301.275 177.845 306.835 184.686 306.835Z",
    fill: "white",
    stroke: "url(#paint20_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M163.61 256.158C163.302 259.953 166.129 263.277 169.918 263.585C170.512 263.626 171.086 263.606 171.639 263.503C171.905 266.027 172.704 268.427 173.912 270.54C176.8 275.67 182.105 279.301 188.413 279.814C198.511 280.635 207.359 273.084 208.158 262.969C208.977 252.854 201.44 243.991 191.342 243.191C184.501 242.637 178.234 245.92 174.67 251.254C173.666 250.454 172.417 249.962 171.045 249.838C167.214 249.531 163.896 252.362 163.61 256.158Z",
    fill: "white",
    stroke: "url(#paint21_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M173.81 259.625C173.81 259.625 173.871 256.137 170.43 256.342",
    stroke: "url(#paint22_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M564.154 337.488H219.996V668.431H564.154V337.488Z",
    fill: "#D4E6FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M289.041 325.486L289.246 344.772L313.333 344.628L313.845 325.67L289.041 325.486Z",
    fill: "white",
    stroke: "url(#paint23_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M294.12 344.423L294.448 332.01",
    stroke: "url(#paint24_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M300.593 343.807L300.92 331.394",
    stroke: "url(#paint25_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M307.045 343.684L307.372 331.271",
    stroke: "url(#paint26_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M128.811 371.362C111.626 408.108 164.306 448.568 164.306 448.568",
    stroke: "white",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M518.049 400.353H266.695V439.069H518.049V400.353Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M518.049 455.319H266.695V494.035H518.049V455.319Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M518.049 511.987H266.695V550.703H518.049V511.987Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M468.033 578.217H316.712V616.933H468.033V578.217Z",
    fill: "url(#paint27_linear_361_3395)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M512.048 313.36C538.744 313.36 560.386 291.681 560.386 264.939C560.386 238.197 538.744 216.518 512.048 216.518C485.352 216.518 463.711 238.197 463.711 264.939C463.711 291.681 485.352 313.36 512.048 313.36Z",
    fill: "white",
    stroke: "url(#paint28_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.22"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9904 668.329H640.429",
    stroke: "url(#paint29_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M590.269 668.329H505.965L494.495 574.278H601.718L590.269 668.329Z",
    fill: "url(#paint30_linear_361_3395)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M608.866 574.278H487.368V595.718H608.866V574.278Z",
    fill: "white",
    stroke: "url(#paint31_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M548.117 574.278V478.421",
    stroke: "url(#paint32_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M548.117 523.662C577.596 523.662 601.493 499.723 601.493 470.194C601.493 440.664 577.596 416.726 548.117 416.726C518.638 416.726 494.741 440.664 494.741 470.194C494.741 499.723 518.638 523.662 548.117 523.662Z",
    fill: "white",
    stroke: "url(#paint33_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M578.438 500.565C595.187 483.787 595.187 456.584 578.438 439.806C561.689 423.028 534.533 423.028 517.784 439.806C501.035 456.584 501.035 483.787 517.784 500.565C534.533 517.343 561.689 517.343 578.438 500.565Z",
    fill: "white",
    stroke: "url(#paint34_linear_361_3395)",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M548.117 574.031C548.117 574.031 548.117 533.264 506.846 528.216C503.384 562.213 548.117 574.031 548.117 574.031Z",
    fill: "url(#paint35_linear_361_3395)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M515.571 539.542L538.347 561.824",
    stroke: "white",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M548.301 574.503C548.301 574.503 548.301 533.735 589.572 528.688C593.013 562.685 548.301 574.503 548.301 574.503Z",
    fill: "url(#paint36_linear_361_3395)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M580.847 540.014L558.051 562.275",
    stroke: "white",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M530.851 464.079V475.959C530.851 485.725 538.695 493.624 548.445 493.624C558.194 493.624 566.08 485.705 566.08 475.959V464.079H530.851ZM550.554 482.237H546.335V473.23H550.554V482.237Z",
    fill: "url(#paint37_linear_361_3395)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M559.443 460.674V458.376C559.443 452.303 554.528 447.358 548.445 447.358C542.382 447.358 537.446 452.282 537.446 458.376V460.674",
    stroke: "url(#paint38_linear_361_3395)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M584.841 407.78C584.841 407.78 620.316 343.684 556.945 307.964",
    stroke: "url(#paint39_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.22"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M362.346 275.854L360.359 260.548L355.607 261.164L346.226 248.915L348.07 244.483L333.835 238.554L332.012 242.986L316.733 244.976L313.824 241.16L301.596 250.536L304.505 254.352L298.586 268.591L293.834 269.227L295.82 284.533L300.572 283.918L309.933 296.166L308.089 300.598L322.324 306.528L324.167 302.096L339.447 300.106L342.355 303.922L354.583 294.545L351.675 290.729L357.594 276.47L362.346 275.854ZM329.677 284.8C322.918 285.682 316.733 280.922 315.852 274.172C314.971 267.401 319.723 261.205 326.482 260.323C333.241 259.441 339.426 264.201 340.307 270.971C341.188 277.721 336.416 283.918 329.677 284.8Z",
    fill: "url(#paint40_linear_361_3395)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.089 128.561H128.319V189.784H342.089V128.561Z",
    fill: "white",
    stroke: "url(#paint41_linear_361_3395)",
    strokeWidth: 0.6218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.22"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M160.373 168.611C165.577 168.611 169.795 164.385 169.795 159.173C169.795 153.96 165.577 149.735 160.373 149.735C155.17 149.735 150.952 153.96 150.952 159.173C150.952 164.385 155.17 168.611 160.373 168.611Z",
    fill: "url(#paint42_linear_361_3395)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M190.175 168.611C195.378 168.611 199.596 164.385 199.596 159.173C199.596 153.96 195.378 149.735 190.175 149.735C184.971 149.735 180.753 153.96 180.753 159.173C180.753 164.385 184.971 168.611 190.175 168.611Z",
    fill: "url(#paint43_linear_361_3395)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M219.955 168.611C225.159 168.611 229.377 164.385 229.377 159.173C229.377 153.96 225.159 149.735 219.955 149.735C214.752 149.735 210.534 153.96 210.534 159.173C210.534 164.385 214.752 168.611 219.955 168.611Z",
    fill: "url(#paint44_linear_361_3395)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M249.736 168.611C254.94 168.611 259.158 164.385 259.158 159.173C259.158 153.96 254.94 149.735 249.736 149.735C244.533 149.735 240.314 153.96 240.314 159.173C240.314 164.385 244.533 168.611 249.736 168.611Z",
    fill: "url(#paint45_linear_361_3395)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M279.517 168.611C284.72 168.611 288.939 164.385 288.939 159.173C288.939 153.96 284.72 149.735 279.517 149.735C274.313 149.735 270.095 153.96 270.095 159.173C270.095 164.385 274.313 168.611 279.517 168.611Z",
    fill: "url(#paint46_linear_361_3395)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M318.719 159.173C318.719 164.384 314.5 168.611 309.298 168.611C304.095 168.611 299.876 164.384 299.876 159.173C299.876 153.961 304.095 149.735 309.298 149.735C314.5 149.755 318.719 153.982 318.719 159.173Z",
    fill: "url(#paint47_linear_361_3395)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M526.626 265.386C522.151 269.868 514.91 269.868 510.436 265.386C505.961 260.903 505.961 253.649 510.436 249.166C514.91 244.684 522.151 244.684 526.626 249.166C531.101 253.649 531.101 260.903 526.626 265.386Z",
    fill: "url(#paint48_linear_361_3395)",
    stroke: "url(#paint49_linear_361_3395)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M518.52 257.266L497.752 278.091L504.245 284.595",
    stroke: "url(#paint50_linear_361_3395)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M508.361 277.003L503.589 272.223",
    stroke: "url(#paint51_linear_361_3395)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M522.673 261.426C520.391 263.712 516.693 263.714 514.388 261.425C512.106 259.139 512.104 255.434 514.39 253.125C516.671 250.84 520.369 250.838 522.673 253.126C524.956 255.414 524.956 259.139 522.673 261.426Z",
    fill: "white",
    stroke: "url(#paint52_linear_361_3395)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_361_3395",
    x1: 416.005,
    y1: 334.202,
    x2: 337.308,
    y2: 330.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_361_3395",
    x1: 407.695,
    y1: 332.868,
    x2: 378.818,
    y2: 331.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_361_3395",
    x1: 102.977,
    y1: 247.042,
    x2: 84.5008,
    y2: 246.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_361_3395",
    x1: 114.341,
    y1: 584.725,
    x2: 71.5877,
    y2: 583.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_361_3395",
    x1: 92.5527,
    y1: 563.411,
    x2: 75.7613,
    y2: 562.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_361_3395",
    x1: 137.018,
    y1: 624.129,
    x2: 127.896,
    y2: 623.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_361_3395",
    x1: 98.4239,
    y1: 537.918,
    x2: 93.9451,
    y2: 537.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_361_3395",
    x1: 200.225,
    y1: 418.287,
    x2: 114.555,
    y2: 411.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_361_3395",
    x1: 139.803,
    y1: 657.917,
    x2: 115.146,
    y2: 655.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_361_3395",
    x1: 220.09,
    y1: 657.917,
    x2: 200.109,
    y2: 656.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_361_3395",
    x1: 192.998,
    y1: 557.999,
    x2: 112.418,
    y2: 555.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_361_3395",
    x1: 196.709,
    y1: 379.51,
    x2: 80.1836,
    y2: 373.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_361_3395",
    x1: 285.706,
    y1: 361.069,
    x2: 235.206,
    y2: 359.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_361_3395",
    x1: 162.462,
    y1: 473.84,
    x2: 134.401,
    y2: 472.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_361_3395",
    x1: 172.247,
    y1: 479.344,
    x2: 167.059,
    y2: 479.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_361_3395",
    x1: 166.881,
    y1: 483.026,
    x2: 161.693,
    y2: 482.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_361_3395",
    x1: 161.842,
    y1: 487.068,
    x2: 156.655,
    y2: 486.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_361_3395",
    x1: 173.763,
    y1: 473.352,
    x2: 169.927,
    y2: 473.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_361_3395",
    x1: 134.329,
    y1: 423.492,
    x2: 86.0324,
    y2: 421.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_361_3395",
    x1: 191.052,
    y1: 251.252,
    x2: 160.12,
    y2: 249.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_361_3395",
    x1: 187.296,
    y1: 281.412,
    x2: 171.558,
    y2: 281.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_361_3395",
    x1: 190.626,
    y1: 262.145,
    x2: 162.334,
    y2: 260.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_361_3395",
    x1: 172.478,
    y1: 258.037,
    x2: 170.333,
    y2: 257.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_361_3395",
    x1: 304.067,
    y1: 335.465,
    x2: 288.351,
    y2: 334.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_361_3395",
    x1: 294.319,
    y1: 338.433,
    x2: 294.111,
    y2: 338.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_361_3395",
    x1: 300.791,
    y1: 337.818,
    x2: 300.583,
    y2: 337.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_361_3395",
    x1: 307.243,
    y1: 337.695,
    x2: 307.035,
    y2: 337.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_361_3395",
    x1: 408.385,
    y1: 598.251,
    x2: 315.115,
    y2: 581.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_361_3395",
    x1: 522.278,
    y1: 266.631,
    x2: 460.937,
    y2: 263.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_361_3395",
    x1: 415.968,
    y1: 668.846,
    x2: 415.428,
    y2: 654.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_361_3395",
    x1: 559.453,
    y1: 622.946,
    x2: 491.462,
    y2: 619.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_361_3395",
    x1: 560.974,
    y1: 585.372,
    x2: 488.526,
    y2: 566.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_361_3395",
    x1: 548.723,
    y1: 528.024,
    x2: 548.087,
    y2: 528.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_361_3395",
    x1: 559.413,
    y1: 472.061,
    x2: 491.678,
    y2: 468.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_361_3395",
    x1: 555.589,
    y1: 464.817,
    x2: 515.292,
    y2: 501.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_361_3395",
    x1: 531.773,
    y1: 551.924,
    x2: 505.456,
    y2: 550.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_361_3395",
    x1: 573.419,
    y1: 552.396,
    x2: 547.102,
    y2: 551.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_361_3395",
    x1: 552.193,
    y1: 479.368,
    x2: 529.86,
    y2: 478.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_361_3395",
    x1: 550.772,
    y1: 454.248,
    x2: 536.864,
    y2: 453.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_361_3395",
    x1: 579.841,
    y1: 359.615,
    x2: 555.818,
    y2: 359.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_361_3395",
    x1: 335.34,
    y1: 273.728,
    x2: 291.87,
    y2: 271.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_361_3395",
    x1: 257.825,
    y1: 160.242,
    x2: 125.245,
    y2: 139.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_361_3395",
    x1: 162.367,
    y1: 159.502,
    x2: 150.411,
    y2: 158.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_361_3395",
    x1: 192.169,
    y1: 159.502,
    x2: 180.212,
    y2: 158.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_361_3395",
    x1: 221.949,
    y1: 159.502,
    x2: 209.993,
    y2: 158.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_361_3395",
    x1: 251.73,
    y1: 159.502,
    x2: 239.774,
    y2: 158.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_361_3395",
    x1: 281.511,
    y1: 159.502,
    x2: 269.555,
    y2: 158.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_361_3395",
    x1: 311.292,
    y1: 159.502,
    x2: 299.335,
    y2: 158.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_361_3395",
    x1: 521.06,
    y1: 257.694,
    x2: 505.894,
    y2: 257.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_361_3395",
    x1: 521.06,
    y1: 257.694,
    x2: 505.894,
    y2: 257.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_361_3395",
    x1: 510.334,
    y1: 271.408,
    x2: 497.145,
    y2: 270.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_361_3395",
    x1: 506.48,
    y1: 274.697,
    x2: 503.452,
    y2: 274.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_361_3395",
    x1: 519.876,
    y1: 257.498,
    x2: 511.812,
    y2: 257.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354975"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginVector);
export default __webpack_public_path__ + "static/media/login-vector.e1ced1517adfe17b6d0e39d83d4c0547.svg";
export { ForwardRef as ReactComponent };